/* eslint-env browser, jquery */
import $ from 'jquery';
import Promise from 'bluebird';

export default class AnimationScroll {
  constructor() {
    this.animations = [];
    this.scrollSpy = [];
  }

  add({ id, animation, options = {} }) {
    this.animations.push({ id, animation, options });
  }

  addScrollSpy({ id, onEnter, onLeave, options = {} }) {
    this.scrollSpy.push({ id, onEnter, onLeave, options });
  }

  start() {
    return Promise.delay(1000).then(() => this.startAnimations()).then(() => this.startScrollSpy());
  }

  startAnimations() {
    const triggers = this.animations
      .map(({ id, animation, options }) => {
        const $elem = $(`#${id}`);
        if (!$elem.length) {
          return null;
        }
        const top = $elem.offset().top;
        const bottom = top + $elem.height();
        return { id, top, bottom, animation, options };
      })
      .filter(trigger => trigger);
    const animationState = { previousScrollTop: 0, triggered: {} };
    this.handler = () => triggerAnimations(animationState, triggers);
    $(window).on('scroll', this.handler);
    this.handler();
  }

  startScrollSpy() {
    const triggers = this.scrollSpy
      .map(({ id, onEnter, onLeave, options }) => {
        const $elem = $(`#${id}`);
        if (!$elem.length) {
          return null;
        }
        const top = $elem.offset().top;
        const bottom = top + $elem.height();
        return { id, top, bottom, onEnter, onLeave, options };
      })
      .filter(trigger => trigger);
    const scrollSpyState = {};
    this.scrollSpyHandler = () => triggerScrollSpy(triggers, scrollSpyState);
    $(window).on('scroll', this.scrollSpyHandler);
    this.scrollSpyHandler();
  }

  reset() {
    this.animations = [];
    $(window).off('scroll', this.handler);
  }
}

function triggerAnimations(animationState, animations) {
  const scrollTop = $(window).scrollTop();
  const isScrollDown = scrollTop >= animationState.previousScrollTop;
  animationState.previousScrollTop = scrollTop;

  if (!isScrollDown) {
    return;
  }

  animations.forEach(({ id, top, bottom, animation, options }) => {
    const offsetTop = options.offsetTop || 0;
    const offsetBottom = options.offsetBottom || 0;
    const triggered = animationState.triggered[id];
    const oneShot = options.oneShot;

    if (
      !(triggered && oneShot) &&
      scrollTop >= top + offsetTop &&
      scrollTop <= bottom + offsetBottom &&
      animation.run
    ) {
      animationState.triggered[id] = true;
      animation.run();
    }
  });
}

function triggerScrollSpy(scrollSpyElements, scrollSpyState) {
  const scrollTop = $(window).scrollTop();

  scrollSpyElements.forEach(({ id, top, bottom, onEnter, onLeave, options }) => {
    const offsetTop = options.offsetTop || 0;
    const offsetBottom = options.offsetBottom || 0;
    const hoveringElement = scrollTop >= top + offsetTop && scrollTop < bottom + offsetBottom;

    if (!scrollSpyState[id] && hoveringElement) {
      scrollSpyState[id] = true;
      return onEnter && onEnter();
    }

    if (scrollSpyState[id] && hoveringElement) {
      return null;
    }

    if (scrollSpyState[id] && !hoveringElement) {
      scrollSpyState[id] = null;
      return onLeave && onLeave();
    }

    if (!scrollSpyState[id] && !hoveringElement) {
      return null;
    }

    return null;
  });
}



// WEBPACK FOOTER //
// ./src/modules/animation-scroll/client.js